// import { memo } from "react";
// import { useRouter } from "next/router";
// import Link from "next/link";
// import PropTypes from "prop-types";
// import ClipLoader from "react-spinners/ClipLoader";
// import { useTranslation } from "next-i18next";
// import { getCloudfrontUrl } from "../utils/mediaHelper";
// import Image from "next/image";
// import Pagination from "../utils/pagination";

// const LatestNews = memo(
//   ({ news, loading, page, totalPages, className = "" }) => {
//     const { t } = useTranslation("news");
//     const router = useRouter();
//     const lang = router.locale || "en";

//     const pageHref = (p) => ({
//       pathname: router.pathname,
//       query: { ...router.query, page: p },
//     });

//     return (
//       <div
//         className={`w-full box-border gap-10 max-w-full text-text-primary  ${className}`}
//       >
//         <h2 className="text-start text-[28px] sm:text-[32px] lg:text-[40px] font-medium leading-[120%] m-0 mb-10">
//           {t("news.list.title")}
//         </h2>

//         {loading ? (
//           <div className="w-full flex justify-center items-center py-20">
//             <ClipLoader color="#EF4444" size={48} />
//           </div>
//         ) : news?.length === 0 ? (
//           <div className="text-lg">No news available.</div>
//         ) : (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
//             {news?.map((news, index) => (
//               <Link
//                 key={`news-${index}`}
//                 href={`/news/${news?.slug}`}
//                 className="block no-underline hover:no-underline focus:no-underline"
//                 aria-label={news?.title || "Open News"}
//               >
//                 <div className="bg-white rounded-[20px] overflow-hidden shadow-md cursor-pointer flex flex-col transition-transform hover:scale-[1.02]">
//                   <div className="relative w-full aspect-[1200/630] overflow-hidden rounded-t-[20px] bg-gray-50">
//                     <Image
//                       src={getCloudfrontUrl(news?.coverImage)}
//                       alt={news?.title || "News cover"}
//                       fill
//                       className="object-contain object-center"
//                       sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
//                       priority={index < 2}
//                     />
//                   </div>
//                   <div className="flex flex-col gap-2 p-4">
//                     <h3 className="text-[14px] font-bold leading-[140%] text-text-primary m-0">
//                       {news?.title}
//                     </h3>
//                   </div>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         )}

//         <Pagination
//           meta={{ page, totalPages: totalPages }}
//           locale={lang}
//           hrefForPage={pageHref}
//           ariaLabel="News pagination"
//         />
//       </div>
//     );
//   },
// );

// LatestNews.propTypes = {
//   news: PropTypes.arrayOf(
//     PropTypes.shape({
//       title: PropTypes.string.isRequired,
//       slug: PropTypes.string.isRequired,
//       coverImage: PropTypes.string.isRequired,
//     }),
//   ).isRequired,
//   loading: PropTypes.bool,
//   page: PropTypes.number.isRequired,
//   setPage: PropTypes.func.isRequired,
//   totalPages: PropTypes.number.isRequired,
//   className: PropTypes.string,
// };

// export default LatestNews;

//components/latest-news.js
import { memo } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "next-i18next";
import { getCloudfrontUrl } from "../utils/mediaHelper";
import Image from "next/image";
import Pagination from "../utils/pagination";

const LatestNews = memo(
  ({ news = [], loading, page, totalPages, className = "" }) => {
    const { t } = useTranslation("news");
    const router = useRouter();
    const lang = router.locale || "en";

    // Clean URLs only: no ?page=1 ever.
    const pageHref = (p) => {
      const query = {};
      if (p > 1) query.page = p;
      return { pathname: router.pathname, query };
    };

    return (
      <div
        className={`w-full box-border gap-10 max-w-full text-text-primary  ${className}`}
      >
        <h2 className="text-start text-[28px] sm:text-[32px] lg:text-[40px] font-medium leading-[120%] m-0 mb-10">
          {t("news.list.title")}
        </h2>

        {loading ? (
          <div className="w-full flex justify-center items-center py-20">
            <ClipLoader color="#EF4444" size={48} />
          </div>
        ) : news.length === 0 ? (
          <div className="text-lg">No news available.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
            {news.map((item, index) => (
              <Link
                key={`news-${index}`}
                href={`/news/${item?.slug}`}
                className="block no-underline hover:no-underline focus:no-underline"
                aria-label={item?.title || "Open News"}
              >
                <div className="bg-white rounded-[20px] overflow-hidden shadow-md cursor-pointer flex flex-col transition-transform hover:scale-[1.02]">
                  <div className="relative w-full aspect-[1200/630] overflow-hidden rounded-t-[20px] bg-gray-50">
                    <Image
                      src={
                        getCloudfrontUrl(item?.coverImage) ||
                        "/blog-posts@3x.png"
                      }
                      alt={item?.title || "News cover"}
                      fill
                      className="object-contain object-center"
                      sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                      priority={index < 2}
                    />
                  </div>
                  <div className="flex flex-col gap-2 p-4">
                    <h3 className="text-[14px] font-bold leading-[140%] text-text-primary m-0">
                      {item?.title}
                    </h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        <Pagination
          meta={{ page, totalPages: totalPages }}
          locale={lang}
          hrefForPage={pageHref}
          ariaLabel="News pagination"
        />
      </div>
    );
  },
);

LatestNews.propTypes = {
  news: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string,
      coverImage: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  className: PropTypes.string,
};

export default LatestNews;
